export type BOMSearch = {
    AlertDay: DayOfWeek;
    AlertFrequency: BOMAlertFrequencyType;
    Alerts: BOMSearchAlert[];
    BatchSize: number;
    BOMPermissionLevel: BOMPermissionLevel;
    CurrentUser: string;
    Distributors: BOMSearchDistributor[];
    EnableLinkSharing: boolean;
    ExportFields: string[];
    HashId: string;
    IsLocked: boolean;
    Name: string;
    OwnerName: string;
    PartCount: number;
    PartExists: boolean;
    Parts: BOMSearchPart[];
    PartSelectionCount: number;
    PossibleDistributors: BOMSearchDistributor[];
    PossibleExportFields: string[];
    SharedUsers: BOMSearchUser[];
    ShareLink: string;
    SortOrder: BOMSortOrder;
    StockFilter: BOMStockFilter;
    TimeStamp: Date;
    UserId: number;
};

export type BOMSearchAlert = {
    Id: number;
    BOMSearchId: number;
    BOMAlertTypeId: BOMAlertTypes;
};

export enum BOMPermissionLevel {
    Public = 0,
    Viewer = 1,
    Editor = 2,
    Owner = 3,
}

export enum BOMSortOrder {
    Default = 1,
    PartNum_Asc = 2,
    PartNum_Desc = 3,
    Manufacturer_Asc = 4,
    Manufacturer_Desc = 5,
    KgCO2e_Asc = 6,
    KgCO2e_Desc = 7,
}

enum BOMStockFilter {
    All,
    Hide_InStock,
    Hide_NoStock,
}

export enum BOMAlertFrequencyType {
    Daily = 1,
    Weekly = 2,
}

export enum DayOfWeek {
    Sunday,
    Monday,
    Tuesday,
    Wednesday,
    Thursday,
    Friday,
    Saturday,
}

export enum BOMAlertTypes {
    AvailabilityChange = 1,
    PurchaseQuantityMetChange = 2,
    LifecycleRiskChange = 3,
    SupplyChainRiskChange = 4,
}
